<template>
  <div class="pricing">
    <site-banner title="Pricing" lead="Designed to scale with your business and help you grow." />
    <div class="relative z-10 px-4 pb-12 mx-auto -mt-12 max-w-7xl">

      <div class="grid gap-8 md:grid-cols-2">
        <!-- Portal -->
        <PricingPortal />

        <!-- Radar -->
        <PricingRadar />

        <!-- Signal -->
        <PricingSignal />

        <div class="flex p-10 bg-gray-100 rounded-lg">
          <fa :icon="['far', 'question-circle']" size="lg" class="mt-1 mr-4 text-gray-500" />
          <div>
            <h4 class="text-xl font-bold">
              Still Not Sure?
            </h4>
            <p class="text-base text-gray-500">
              Get a personalised demo of Fleetbeacon.
            </p>
            <router-link :to="{ name: 'Request' }" class="mt-3 btn btn-secondary">
              Book A Demo
            </router-link>
          </div>
        </div>
        <div class="flex p-10 bg-gray-100 rounded-lg">
          <fa :icon="['far', 'cars']" size="lg" class="mt-1 mr-4 text-gray-500" />
          <div>
            <h4 class="text-xl font-bold">
              Large Fleet or Complex Needs?
            </h4>
            <p class="text-base text-gray-500">
              Talk to us about custom functionality and volume pricing.
            </p>
            <router-link :to="{ name: 'Contact' }" class="mt-3 btn btn-secondary">
              Contact Us
            </router-link>
          </div>
        </div>
      </div>

      
    </div>
  </div>
</template>

<script>
  import features from '@/store/features'
  import SiteBanner from '@/components/SiteBanner'
  import PricingPortal from '@/views/site/pricing/PricingPortal'
  import PricingRadar from '@/views/site/pricing/PricingRadar'
  import PricingSignal from '@/views/site/pricing/PricingSignal'

  export default {
    name: 'Pricing',

    metaInfo: {
      title: 'Pricing'
    },

    components: {
      SiteBanner,
      PricingPortal,
      PricingRadar,
      PricingSignal
    },

    computed: {
      currency () {
        if (this.$cookies.get('currency_code') === 'EUR') {
          return { code: 'EUR', symbol: '€' }
        } else if (this.$cookies.get('currency_code') === 'ZAR') {
          return { code: 'ZAR', symbol: 'R' }
        } else if (this.$cookies.get('currency_code') === 'GBP') {
          return { code: 'GBP', symbol: '￡' }
        } else if (this.$cookies.get('currency_code') === 'NZD') {
          return { code: 'NZD', symbol: '$' }
        } else if (this.$cookies.get('currency_code') === 'AUD') {
          return { code: 'AUD', symbol: '$' }
        } else {
          return { code: 'USD', symbol: '$' }
        }
      },

      orderPrice () {
        return this.currency.code === 'ZAR' ? '2.50' : '0.25'
      },

      vehiclePrice () {
        return this.currency.code === 'ZAR' ? '50' : '5'
      },

      basePrice () {
        return this.currency.code === 'ZAR' ? '500' : '50'
      }
    },

    data () {
      return {
        features,
        products: [
          {
            icon: 'sync',
            name: 'Automations',
            colorBorder: 'border-purple-500',
            colorText: 'text-purple-600',
            colorBg: 'bg-purple-500',
            colorBtn: 'hover:bg-purple-400 bg-purple-500 border-purple-500',
            pricing: {
              base: 50,
              unit: 5,
              included: 10,
              conversion: 10
            },
            unit: 'vehicle',
            features: [
              `Get an AI-based system that monitors your fleet 24/7`,
              `Configure it to your company's particular specifications`,
              `Receive realtime alerts and notifications for events`,
              `Automatically coach and discipline your drivers via PRO terminal`
            ]
          },
          {
            icon: 'inbox-in',
            name: 'Orders',
            colorBorder: 'border-teal-500',
            colorText: 'text-teal-600',
            colorBg: 'bg-teal-400',
            colorBtn: 'hover:bg-teal-300 bg-teal-400 border-teal-400',
            pricing: {
              base: 50,
              unit: 0.25,
              included: 200,
              conversion: 10
            },
            unit: 'order',
            terms: 'Starting at $500/mo which includes your first 10 vehicles.',
            features: [
              `Accept orders via embeddable and bulk upload forms on your website`,
              `Automatically send customers status and time updates for their orders`,
              `Give customers the ability to track their orders live on their phone`,
              `Capture feedback from customers after order is complete`
            ]
          },
          {
            icon: 'cabinet-filing',
            name: 'Records',
            colorBorder: 'border-blue-500',
            colorText: 'text-blue-600',
            colorBg: 'bg-blue-500',
            colorBtn: 'hover:bg-blue-400 bg-blue-500 border-blue-500',
            pricing: {
              base: 50,
              unit: 5,
              included: 10,
              conversion: 10
            },
            unit: 'vehicle',
            terms: 'Starting at $500/mo which includes your first 10 vehicles.',
            features: [
              `Capture and categorise all your fleet expenses in one place`,
              `Automatically sync additional telemetry data for your fleet`,
              `Pull reports and business insights from a central dashboard`,
              `Easily calculate CPK and overall costs for any time period`
            ]
          }
        ]
      }
    },

    methods: {
      calculatePrice (product, type) {
        if (this.currency.code === 'ZAR') { 
          let price = (product.pricing[type] * product.pricing.conversion).toFixed(2)
          if (price.split('.')[1] === '00') {
            return price.split('.')[0]
          } else {
            return price
          }
        } else {
          return product.pricing[type]
        }
      }
    }
  }
</script>